module.exports = __webpack_public_path__ + "static/media/css3.b3197426.svg";